import { effect, inject, Signal } from "@angular/core";
import { BlockUiService } from "@merchant-webapp/components";
import { EmptyFeatureResult, signalStoreFeature, SignalStoreFeature, withHooks } from "@ngrx/signals";
import {
  deriveCallStateKeys,
  ErCallStateSignals,
  ErCallStateSlice,
  ErNamedCallStateSignals,
  ErNamedCallStateSlice,
  getCollectionArray,
} from "./with-er-call-state";

export function withBlockUiOnLoading<Collection extends string>(config: {
  collections: Collection[];
}): SignalStoreFeature<
  EmptyFeatureResult & {
    state: ErNamedCallStateSlice<Collection>;
    props: ErNamedCallStateSignals<Collection>;
  },
  EmptyFeatureResult & {
    state: ErNamedCallStateSlice<Collection>;
    props: ErNamedCallStateSignals<Collection>;
  }
>;
export function withBlockUiOnLoading<Collection extends string>(config: {
  collection: Collection;
}): SignalStoreFeature<
  EmptyFeatureResult & {
    state: ErNamedCallStateSlice<Collection>;
    props: ErNamedCallStateSignals<Collection>;
  },
  EmptyFeatureResult & {
    state: ErNamedCallStateSlice<Collection>;
    props: ErNamedCallStateSignals<Collection>;
  }
>;
// TODO: See why this overload is not ok...
export function withBlockUiOnLoading(): SignalStoreFeature<
  EmptyFeatureResult & {
    state: ErCallStateSlice;
    props: ErCallStateSignals;
  },
  EmptyFeatureResult & {
    state: ErCallStateSlice;
    props: ErCallStateSignals;
  }
>;

// TODO: This works, but it has to be more extensible, because on all entityLoad I don't want this behavior, but on one entity load I do
export function withBlockUiOnLoading<Collection extends string>(
  config?:
    | {
        collection: Collection;
      }
    | {
        collections: Collection[];
      },
): SignalStoreFeature<any, any> {
  return signalStoreFeature(
    withHooks({
      onInit: (state: Record<string, unknown>, blockUiService = inject(BlockUiService)) => {
        effect(() => {
          if (config) {
            const collections = getCollectionArray(config);
            if (collections) {
              collections.forEach((col: string) => {
                const { loadedKey, blockingLoadingKey, errorKey } = deriveCallStateKeys(col);
                const loaded = state[loadedKey] as Signal<boolean>;
                const blockingLoading = state[blockingLoadingKey] as Signal<boolean>;
                const error = state[errorKey] as Signal<boolean>;

                if (error() || loaded()) {
                  blockUiService.unblockUi();
                } else if (blockingLoading()) {
                  blockUiService.blockUi();
                }
              });
            }
          }
        });
      },
    }),
  );
}
